// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zAW--effects--shadow_xs{box-shadow:0px 0px 0.1rem rgba(0,0,0,0.2)}.GOE--effects--shadow_s{box-shadow:0px 0px 0.6rem rgba(0,0,0,0.2)}.zew--effects--shadow_m{box-shadow:0px 0px 1.2rem rgba(0,0,0,0.2)}.E6Z--effects--shadow_l{box-shadow:0px 0px 2rem rgba(0,0,0,0.1)}.C97--effects--shadow_xl{box-shadow:0px 0px 2.8rem rgba(0,0,0,0.1)}.Jjq--effects--handleShadow{box-shadow:0 2px 4px 0 rgba(0,0,0,0.2)}.Ht8--effects--floating{box-shadow:0 20px 28px 0 rgba(4,68,77,0.15)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shadow_xs": "zAW--effects--shadow_xs",
	"shadow_s": "GOE--effects--shadow_s",
	"shadow_m": "zew--effects--shadow_m",
	"shadow_l": "E6Z--effects--shadow_l",
	"shadow_xl": "C97--effects--shadow_xl",
	"handleShadow": "Jjq--effects--handleShadow",
	"floating": "Ht8--effects--floating"
};
module.exports = ___CSS_LOADER_EXPORT___;
